import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

function upsertMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`)
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute(attr, key)
    document.head.appendChild(el)
  }
  el.setAttribute('content', content)
}

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home.vue'),
    meta: {
      title: 'Toeato — Food delivery',
      metaTags: [
        {
          name: 'description',
          content:
            "Discover Toeato: Nepal's food delivery app for quick ordering, reliable delivery, and a simple experience.",
        },
        {
          property: 'og:description',
          content:
            "Discover Toeato: Nepal's food delivery app for quick ordering, reliable delivery, and a simple experience.",
        },
      ],
    },
  },
  {
    path: '/delete_account',
    name: 'Delete Account',
    component: () => import('../views/DeleteAccount.vue'),
    meta: {
      title: 'Delete account — Toeato',
      metaTags: [
        {
          name: 'description',
          content:
            'Request deletion of your Toeato account and associated data. Submit the form or contact support.',
        },
        {
          property: 'og:description',
          content:
            'Request deletion of your Toeato account and associated data. Submit the form or contact support.',
        },
      ],
    },
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import('../views/Contact.vue'),
    meta: {
      title: 'Contact — Toeato',
      metaTags: [
        {
          name: 'description',
          content:
            'Contact Toeato for support, partnerships, or general enquiries. Email, phone, and message form.',
        },
        {
          property: 'og:description',
          content:
            'Contact Toeato for support, partnerships, or general enquiries. Email, phone, and message form.',
        },
      ],
    },
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('../views/About.vue'),
    meta: {
      title: 'About — Toeato',
      metaTags: [
        {
          name: 'description',
          content:
            "Learn about Toeato's mission, values, and how we power food delivery across Nepal.",
        },
        {
          property: 'og:description',
          content:
            "Learn about Toeato's mission, values, and how we power food delivery across Nepal.",
        },
      ],
    },
  },
  {
    path: '/careers',
    name: 'Careers',
    component: () => import('../views/Careers.vue'),
    meta: {
      title: 'Careers — Toeato',
      metaTags: [
        {
          name: 'description',
          content:
            'Join Toeato and help build food delivery for Nepal. Open roles, perks, and how to apply.',
        },
        {
          property: 'og:description',
          content:
            'Join Toeato and help build food delivery for Nepal. Open roles, perks, and how to apply.',
        },
      ],
    },
  },
  {
    path: '/privacy-policy',
    name: 'Privacy Policy',
    component: () => import('../views/PrivacyPolicy.vue'),
    meta: {
      title: 'Privacy policy — Toeato',
      metaTags: [
        {
          name: 'description',
          content:
            "Read Toeato's privacy and data-safety commitments: encryption in transit, deletion requests, and no third-party sharing.",
        },
        {
          property: 'og:description',
          content:
            "Read Toeato's privacy and data-safety commitments: encryption in transit, deletion requests, and no third-party sharing.",
        },
      ],
    },
  },
]

const router = new VueRouter({
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition
    if (to.hash) {
      return { selector: to.hash, behavior: 'smooth' }
    }
    return { x: 0, y: 0 }
  },
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

router.afterEach((to) => {
  const meta = to.meta || {}
  document.title = meta.title || 'Toeato'
  const tags = meta.metaTags || []
  tags.forEach((tag) => {
    if (tag.name) upsertMeta('name', tag.name, tag.content)
    if (tag.property) upsertMeta('property', tag.property, tag.content)
  })
})

export default router
